import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { FeedPostProvider } from "./contexts/FeedPostContext";
import Login from "./components/Login";
import Chat from "./components/Chat";
import ProtectedRoute from "./components/ProtectedRoute";
import VideoGenerator from "./components/VideoGenerator";
import CheckoutSuccess from "./components/CheckoutSuccess";
import FeedView from "./components/FeedView";
import SharedDebateView from "./components/SharedDebateView";
import { updateAppViewportHeight } from "./utils/browserViewport";
import { FEED_ENABLED } from "./utils/features";

function App() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const updateHeight = () => updateAppViewportHeight(viewport);
    updateHeight();
    viewport.addEventListener("resize", updateHeight);
    return () => { viewport.removeEventListener("resize", updateHeight); document.documentElement.style.removeProperty("--app-height"); };
  }, []);
  return (
    <ThemeProvider>
      <AuthProvider>
        <FeedPostProvider>
        <Router>
          <div className="app-root">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/checkout/success"
                element={
                  <ProtectedRoute>
                    <CheckoutSuccess />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/video"
                element={
                  <ProtectedRoute>
                    <VideoGenerator />
                  </ProtectedRoute>
                }
              />
              {FEED_ENABLED && <Route path="/feed" element={<FeedView />} />}
              {FEED_ENABLED && <Route path="/feed/moderation" element={<FeedView moderation />} />}
              {FEED_ENABLED && <Route path="/feed/:postId" element={<FeedView />} />}
              <Route path="/d/:shareId" element={<SharedDebateView />} />
              <Route path="/" element={<Chat />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
        </FeedPostProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
